import {runCallback} from '../utils/run-callback';
import {convincely, reusable, systemImport} from './convincely';

const callbacks = reusable('callbacks', []);
const scripts = reusable('scripts', []);

convincely.ready = () => {
  callbacks.forEach(runCallback);
};

convincely.onload = () => {
  Promise.all(scripts.map(systemImport)).then(convincely.ready);
};

/**
 * @param {Function} callback
 */
export function addReadyCallback(callback) {
  callbacks.push(callback);
}

/**
 * @param {string} script
 */
export function addScript(script) {
  if (script) {
    scripts.push(script);
  }
}
